import React from "react";
import styled from "styled-components";

import { Xwrapper } from "react-xarrows";

import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DataTypePicker } from "../../../CommonUI/DataTypePicker/DataTypePicker";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { RuleDesignerRender, RuleToolbarRender } from "../../DesignUI/CommonStyles";
import { TreeRuleConstant } from "../../../rule-engine-core/Rule/Tree/Common/TreeRuleConstant";
import { TreeRuleConfiguration } from "../../../rule-engine-core/Rule/Tree/TreeRuleConfiguration";
import { TreeRuleEditContext } from "../../../rule-engine-core/Rule/Tree/TreeRuleEditContext";
import { XTreeRuleNode } from "./XTreeRuleNode";

import { ValidationInformation } from "../../DesignUI/ValidationInformation";
import { TestContext } from "../../../CommonUI/Testing/TestContext";
import { TestResult } from "../../../CommonUI/Testing/TestResult";
import { TreeRuleBuilder } from "../TreeRuleBuilder";

interface ITreeRuleDesigner {
    ruleDefinition: TreeRuleConfiguration;
    editContext: TreeRuleEditContext;
    treeRuleBuilder?: TreeRuleBuilder;
}

export const TreeRuleDesigner = ({ ruleDefinition, editContext, treeRuleBuilder }: ITreeRuleDesigner) => {
    const testContext = React.useContext(TestContext);

    if (testContext) {
        return (
            <RuleDesignerRender id={TreeRuleConstant.DESIGN_SURFACE_ID}>
                <RuleEditorDesigner>
                    <Xwrapper>
                        <XTreeRuleNode
                            node={ruleDefinition._root}
                            editContext={editContext}
                            ruleDefinition={ruleDefinition}
                            treeRuleBuilder={treeRuleBuilder}
                        />
                    </Xwrapper>
                </RuleEditorDesigner>
                <TestResult executableId={ruleDefinition._id} />
            </RuleDesignerRender>
        );
    }

    return (
        <RuleDesignerRender id={TreeRuleConstant.DESIGN_SURFACE_ID}>
            <RuleToolbarRender>
                <DataTypePicker
                    variant={"header"}
                    dataDef={ruleDefinition.getRuleResult()}
                    width={"150px"}
                    label={"Result:"}
                    updateCallback={(newType: IDataDefinition) => {
                        ruleDefinition.executionResult = newType;
                        StateManager.changed(ruleDefinition);
                    }}
                    readonly={!ruleDefinition.canChangeOutputs}
                />
                {/* <SettingButton /> */}
            </RuleToolbarRender>
            <RuleEditorDesigner>
                <Xwrapper>
                    <XTreeRuleNode
                        node={ruleDefinition._root}
                        editContext={editContext}
                        ruleDefinition={ruleDefinition}
                        treeRuleBuilder={treeRuleBuilder}
                    />
                </Xwrapper>
            </RuleEditorDesigner>
            <ObserveState
                listenTo={ruleDefinition}
                control={() => <ValidationInformation provider={ruleDefinition} />}
            />
        </RuleDesignerRender>
    );
};

const RuleEditorDesigner = styled.div`
    padding-left: 36px;
    padding-top: 36px;

    flex: 1;
    overflow: auto;

    position: relative;
`;
